import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfService } from 'src/conf.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfig } from 'src/app/config/apiConfig';
@Injectable({
  providedIn: 'root'
})
export class LabRequisitionService {
  private rootUrl: string;
  private labRequisitionAPIUrl;
  public selectedFacility = new BehaviorSubject<any>('');
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.labRequisitionAPIUrl = ApiConfig.LabRequisitionApiConfig;

  }

  getLabelSummary(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getLabelSummary}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  printLabelSummary(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.printLabelSummary}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  printShippingManifest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.printShippingManifest}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getfacilityDetails(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getFacilityDetails}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  createLabRequisition(ObjParam: any, isRedraw: boolean): Observable<any> {
    if (isRedraw) {
      return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.redrawLabResult}`, ObjParam)
        .pipe(
          tap(() => {
            //
          })
        );
    }
    else {
      return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.createLabRequisition}`, ObjParam)
        .pipe(
          tap(() => {
            //
          })
        );
    }
  }
  getLabRequisitions(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getLabRequisitionData}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getShipmentReceivedDate(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getShipmentReceivedDate}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updateDrawDate(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.updateDrawDate}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  updatePrintLabelDate(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.updatePrintLabelDate}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  cancelLabRequisition(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.cancelRequisition}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  updateLabRequisitionStatus(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.updateLabRequisitionStatus}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  updateShippingManifest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.updateShippingManifest}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  CreateRequisitionForAdditionalTest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.CreateRequisitionForAdditionalTest}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabResults(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getLabResult}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabRequisitionHistory(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getLabRequisitionHistory}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  printZPL(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.printZPL}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  isZebraPrinterAvailable(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.isZebraPrinterAvailable}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  //This api accepts multiple lab requisition ids as inout and returns first print label dates for all of those ids
  getPrintLabelDate(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequisitionAPIUrl.getPrintLabelDate}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
